<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useToast } from 'vuestic-ui'
import { deleteInteraction, getAllInteractions } from '../../../core/requests/Interactions'
import { format } from 'date-fns'

defineEmits(['close'])

const props = defineProps({
  data: {
    default: null,
    type: Object,
  },
})

const isOnProgress = ref(false)
const showConfirm: any = ref(null)
const { notify } = useToast()
const interactions: any = ref([])

const getData = async () => {
  isOnProgress.value = true
  const data: any = await getAllInteractions(props.data?.id)
  interactions.value = data.map((e: any) => ({
    ...e,
    createdAt: format(new Date(e.created_at), 'dd/MM/yyyy hh:mm aa'),
  }))
  isOnProgress.value = false
}
onMounted(async () => {
  if (props.data) {
    getData()
  }
})

const needConfirm = (item: any) => {
  showConfirm.value = item
}
const doChangeStatus = async () => {
  await deleteInteraction(showConfirm.value?.id)
  notify({
    message: 'Interacción eliminada correctamente',
    color: 'success',
  })

  showConfirm.value = false
  getData()
}
</script>

<template>
  <VaInnerLoading :loading="isOnProgress">
    <div class="cxt-interactions overflow-y-scroll px-3 py-2 mt-2">
      <ol class="relative border-s border-primary">
        <li
          v-for="i of interactions"
          :key="i"
          class="mb-5 ms-4 rounded pt-2 px-3"
          :class="i.editable ? 'pb-4 bg-gray-100' : 'pb-2 bg-blue-100'"
        >
          <div class="absolute w-3 h-3 bg-primary rounded-full mt-1.5 -start-1.5 border border-white"></div>
          <time class="mb-1 text-xs font-normal leading-none text-gray-400 dark:text-gray-500">{{ i.createdAt }}</time>
          <span
            v-if="i.comment_label"
            class="text-xs ml-3 font-bold me-2 px-2.5 py-0.5 rounded"
            :class="
              i.editable
                ? 'bg-blue-100'
                : i.comment_label === 'Enviado'
                  ? 'bg-primary text-white'
                  : i.comment_label === 'En Evaluación'
                    ? 'bg-info text-white'
                    : i.comment_label === 'Rechazado'
                      ? 'bg-danger text-white'
                      : 'bg-success text-white'
            "
            >{{ i.comment_label }}</span
          >
          <h3 v-if="i.editable" class="text-xs my-1 font-semibold text-gray-900">
            Por: <span class="capitalize">{{ i.creator?.name }}</span>
          </h3>
          <p class="text-xs text-gray-500" :class="i.editable ? 'font-normal' : 'font-semibold'">
            {{ i.comment }}
          </p>

          <h3 v-if="!i.editable" class="text-xs font-semibold text-gray-900">
            Por: <span class="capitalize">{{ i.creator?.name }}</span>
          </h3>
          <VaButton
            v-if="i.editable"
            class="mt-4 material-symbols-outlined text-xs"
            icon="close"
            color="danger"
            @click="needConfirm(i)"
          >
            <span class="pl-1">Eliminar </span>
          </VaButton>
        </li>
      </ol>
    </div>
  </VaInnerLoading>

  <VaModal v-model="showConfirm" size="250px" hide-default-actions no-dismiss>
    <p class="text-sm">¿Deseas eliminar esta interacción?</p>
    <template #footer>
      <VaButton size="small" preset="secondary" class="mr-1" @click="showConfirm = null"> Cancelar</VaButton>
      <VaButton size="small" :loading="isOnProgress" @click="doChangeStatus"> Continuar</VaButton>
    </template>
  </VaModal>
</template>

<style lang="scss">
.cxt-interactions {
  height: 300px;
}
</style>
